"use strict";

exports.__esModule = true;
exports.KeyColorWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var KeyColorWrapper = exports.KeyColorWrapper = _styledComponents["default"].table.withConfig({
  displayName: "KeyColorWrapper",
  componentId: "sc-1umumz4-0"
})(["", ""], function (_ref) {
  var keyColorArray = _ref.keyColorArray;
  return keyColorArray.map(function (item) {
    return "[data-key=\"" + item.key + "\"]{\n        fill: " + item.color + ";\n        background: " + item.color + ";\n      }";
  }).join(" ");
});